import React, { useState, useEffect } from 'react';
import styles from "./dubai-luxury-adventure.module.css";
import PromoSidebar from "../../../PromoSidebar/PromoSidebar";
// import FooterBottom from "../../../../Footer/SocialLinks";
import CTASection from "../../../../CTASection/CTASection";
import BlogNavigator from "../../../BlogNavigator/BlogNavigator.js";
import { travelBlogs } from "../Travelinternational.js";
import FAQSection from '../../../../Contact/FAQSection.js';

import d1 from './dubai beaches.png';
import d2 from './dubai best food.png';
import d3 from './dubai festivals.png';
import d4 from './dubai honeymoon.png';
import d5 from './DUBAI shopping.png';
import d6 from './dubai thing to do.png';
import d7 from './Dubai with family.png';
import d8 from './dubai attractions images.png';
import d9 from './dubai night life.png';
import d10 from  './dubai.webp';

 

function useScrollSpy(sectionIds) {
  useEffect(() => {
    const handleScroll = () => {
      for (let id of sectionIds) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            window.history.replaceState(null, "", `#${id}`);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [sectionIds]);
}
function Carousel({ images = [], interval = 3000, showDots = true }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!images || images.length <= 1) return;
    const timer = setInterval(() => {
      setIndex(prev => (prev + 1) % images.length);
    }, interval);

    return () => clearInterval(timer);
  }, [images, interval]);

  if (!images || images.length === 0) return null;

  return (
    <div className={styles.carousel}>
      {images.map((item, i) => (
        <img
          key={item.id ?? i}
          src={item.img}
          alt={item.alt ?? `slide-${i}`}
          className={`${styles.slide} ${i === index ? styles.active : ""}`}
          style={{ display: i === index ? undefined : "none" }}
        />
      ))}

      {showDots && images.length > 1 && (
        <div className={styles.carouselDots}>
          {images.map((_, i) => (
            <button
              key={i}
              onClick={() => setIndex(i)}
              className={`${styles.dot} ${i === index ? styles.dotActive : ""}`}
              aria-label={`Go to slide ${i + 1}`}
              type="button"
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default function DubaiLuxuryAdventure() {
 

  const sections = [
{
  id: " Best Places to Visit in Dubai in 2026",
  title: "Dubai’s Crown Jewels: Must-See Attractions",
  paragraphs: [
    `Dubai isn’t just a destination; it’s a masterclass in human imagination. One moment you’re standing at the foot of a record-breaking skyscraper, and the next, you’re lost in an immersive world that feels like it belongs in the next century.`,
    `Whether it’s your very first trip or a long-awaited return, these iconic landmarks are the heart and soul of the Dubai experience. They are the spots that make you stop, stare, and realize that here, the word 'impossible' doesn't exist.`
  ],
  subSections: [
    {
      title: "Iconic Landmarks (The Big Ones)",
      items: [
        {
          title: "Burj Khalifa",
          link: "/packages",
          desc: "Stand on top of the world. The view from the 124th floor makes the entire city look like a beautifully crafted miniature model."
        },
        {
          title: "Dubai Frame",
          
          desc: "A golden window to the city’s soul, offering a stunning contrast between Old Dubai and New Dubai."
        },
        {
          title: "Museum of the Future",
          
          desc: "Far from a typical museum; it’s a silver masterpiece that lets you step into the world of 2071."
        },
        {
          title: "Palm Jumeirah",
          
          desc: "A man-made marvel shaped like a palm tree that redefined luxury living and island vibes forever."
        }
      ]
    },
    {
      title: "Entertainment & Non-Stop Fun",
      items: [
        {
          title: "The Dubai Mall",
          link: "/packages",
          desc: "It’s more than just shopping; with an indoor aquarium and a massive VR Park, you could easily spend a whole day here."
        },
        {
          title: "The Dubai Fountain",
          
          desc: "Watch the water dance to music and lights right at the base of the Burj Khalifa—it’s pure magic after sunset."
        },
        {
          title: "Atlantis The Palm",
          
          desc: "Home to Aquaventure, where you can brave record-breaking waterslides or just relax on a private beach."
        },
        {
          title: "Global Village",
          
          desc: "A seasonal favorite (Nov–March) where you can shop, eat, and enjoy performances from over 90 cultures."
        },
        {
          title: "Miracle Garden",
          
          desc: "A floral wonderland featuring over 150 million flowers arranged in breathtaking designs."
        }
      ]
    }
  ],
  carouselImages: [
    { id: "ta-1", img: d8, alt: "Looking up at the Burj Khalifa" },
  ],
},

    {
  id: "top-activities-dubai-2026",
  title: "Top Things to Do in Dubai: From Adventure to Luxury",
  paragraphs: [
    `Dubai is a city that thrives on "firsts" and "bests." Beyond the glittering skyline lies a playground for every type of traveler. Whether you’re chasing an adrenaline rush in the desert or looking to unwind in the lap of luxury, the city offers experiences that stay with you long after the flight home.`,
    `From soaring above the clouds to gliding over the dunes, here are the absolute essentials for your Dubai bucket list.`
  ],
  subSections: [
    {
      title: "Adrenaline & Adventure",
      items: [
 {
          title: "Desert Safari",
          link: "/packages",
          desc: "The ultimate Dubai rite of passage. Experience heart-pounding dune bashing followed by a quiet evening of camel rides and a traditional BBQ under the stars."
        },     
        "Skydive Dubai – If you’ve ever dreamed of flying, this is the place. Freefall over the Palm Jumeirah for a view that most people only see on postcards.",
        "Jet Ski at JBR – Zip across the Arabian Gulf with the stunning Jumeirah Beach Residence skyline as your backdrop.",
        "Quad Biking – Take control and conquer the vast sand dunes for a gritty, off-road desert adventure."
      ]
    },
    {
      title: "High-End Luxury",
      items: [
        "Helicopter Tour – Get a bird’s-eye view of the world’s most famous landmarks, from the Burj Al Arab to the twisting towers of the Marina.",
        "Marina Dhow Cruise – Spend a romantic evening on a traditional wooden boat, enjoying a buffet dinner as the city lights reflect off the water.",
        "Hot Air Balloon – Float silently over the desert at sunrise. It’s the most peaceful way to spot Arabian oryx and gazelles in their natural habitat."
      ]
    },
    {
      title: "Only in Dubai",
      items: [
        "Ski Dubai – Trade your swimsuit for a parka. You can literally go skiing or play with penguins in the middle of a desert mall.",
        "Ain Dubai – Take a ride on the world's largest observation wheel for a slow-motion panoramic tour of the entire coastline."
      ]
    }
  ],
  carouselImages: [
    { id: "td-1", img: d6, alt: "Golden hour in the Dubai desert" },
    
  ],
},
{
  id: "best-shopping-malls-souks",
  title: "Dubai Shopping Guide: Best Malls & Traditional Souks",
  paragraphs: [
    `In Dubai, shopping isn't just a chore—it’s an art form. Whether you’re hunting for the latest runway fashion in a futuristic mall or haggling for hand-woven carpets in a sun-drenched alleyway, the city offers a retail therapy experience like nowhere else on earth.`,
    `If you time your visit during the iconic Dubai Shopping Festival (DSF), you’ll find the entire city transformed into a massive celebration of discounts, fireworks, and lucky draws.`
  ],
  subSections: [
    {
      title: "Glittering Malls & Modern Luxury",
      items: [
        "The Dubai Mall – A city within a city. With over 1,200 stores, it’s home to everything from high-street favorites to the ultra-exclusive Fashion Avenue.",
        "Mall of the Emirates – Famous for its high-end boutiques and the incredible Ski Dubai, making it the perfect spot for luxury shopping followed by some snow time.",
        "Dubai Outlet Village – The place to go for designer labels at dream prices. Perfect for those who love a good bargain on premium brands."
      ]
    },
    {
      title: "The Soul of Dubai: Traditional Souks",
      items: [
        "Gold Souk – A must-visit sensory experience where window after window glows with authentic gold, silver, and precious stones.",
        "Spice Souk – Follow your nose to this historic market filled with the aroma of premium saffron, exotic herbs, and traditional Arabic fragrances.",
        "Meena Bazaar – A vibrant hub for Indian textiles, jewelry, and budget-friendly finds that feels like a home away from home."
      ]
    },
    {
      title: "Cultural Shopping",
      items: [
        "Global Village – An open-air extravaganza where you can pick up unique handicrafts, spices, and clothing from over 90 different countries in one evening."
      ]
    }
  ],
  carouselImages: [
    { id: "sh-1", img: d5, alt: "The grand interior of a luxury Dubai mall" },
  
  ],
},

  {
  id: "best-dubai-beaches-beach-clubs",
  title: "Best Dubai Beaches & Beach Clubs to Visit in 2026",
  paragraphs: [
    `Dubai’s coastline is a stunning blend of turquoise waters and futuristic architecture. It’s one of the few places in the world where you can work on your tan while staring up at some of the tallest buildings on the planet.`,
    `Whether you're looking for a high-energy beach club with a DJ, a family-friendly spot for kite surfing, or just a quiet corner to watch the sun dip behind the Burj Al Arab, there is a stretch of sand here perfectly suited to your mood.`
  ],
  subSections: [
    {
      title: "The Lively Hotspots",
      items: [
        "JBR Beach (The Beach) – The heart of the city's coastal life. It’s packed with watersports, seaside cafes, and a vibrant promenade that stays alive well into the night.",
        "Kite Beach – The ultimate destination for fitness lovers and foodies. Watch colorful kitesurfers dominate the sky while you enjoy the jogging tracks and quirky food trucks.",
        "La Mer – A trendy, industrial-chic beachfront that is practically built for Instagram. Come here for the colorful beach huts, boutique shopping, and great dining."
      ]
    },
    {
      title: "Scenic & Chill Retreats",
      items: [
        "Sunset Beach (Umm Suqeim) – The name says it all. This is the absolute best spot to snap that iconic photo with the Burj Al Arab as your backdrop as the sky turns golden.",
        "Palm West Beach – A luxury beachfront promenade on the Palm Jumeirah. It’s perfect for a sunset stroll or a premium sundowner at one of its many high-end beach clubs."
      ]
    }
  ],
  carouselImages: [
    { id: "be-1", img: d1, alt: "Golden hour at JBR beach" },
  ],
},

 {
  id: "best-restaurants-indian-food-dubai",
  title: "Where to Eat in Dubai: Best Indian & Fine Dining Restaurants",
  paragraphs: [
    `Dubai is a true melting pot of flavors, where humble street food stalls sit comfortably alongside world-renowned Michelin-starred restaurants. Whether you are craving the comforts of home or looking to expand your palate with Middle Eastern spices, the city’s food scene is an adventure in itself.`,
    `For Indian travelers, Dubai is exceptionally welcoming. From authentic Jain and vegan meals to grand North Indian thalis, you will never be far from a taste that feels like home—just with a spectacular skyline view.`
  ],
  subSections: [
    {
      title: "Indian & Vegetarian Favorites",
      items: [
        "Rasoi Ghar – Famous for its soul-satisfying, unlimited pure vegetarian thali.",
        "Aryaas – The go-to spot for crispy dosas and South Indian comfort food.",
        "Gazebo – Renowned for its aromatic biryanis and authentic Mughlai heritage dishes.",
        "Sthan – A trendy spot that blends the best of Indian, Pakistani, and Persian street food."
      ]
    },
    {
      title: "Authentic Arabic Flavors",
      items: [
        "Shawarma – The undisputed king of Dubai’s street food. You simply haven't visited Dubai until you've grabbed one on the go.",
        "Falafel – Crispy on the outside, fluffy on the inside—the perfect vegetarian-friendly Middle Eastern snack.",
        "Kunafa – A warm, cheesy, and syrupy dessert that is guaranteed to be your new obsession.",
        "Mixed Grill – A platter of succulent kebabs and grilled meats, perfect for sharing."
      ]
    },
    {
      title: "Signature & Luxury Dining",
      items: [
        "Dinner in the Sky – A bucket-list experience where you enjoy a gourmet meal while suspended 50 meters in the air.",
        "Armani/Ristorante – Experience sophisticated Italian fine dining right inside the iconic Burj Khalifa.",
        "Pierchic – Often called the most romantic restaurant in the city, set at the end of a pier with stunning ocean views."
      ]
    },
    {
      title: "Local Must-Trys & Cafés",
      items: [
        "Karak Tea – A strong, spiced milk tea that is the pulse of Dubai's daily life.",
        "Luqaimat – Deep-fried dough balls drizzled with date syrup; a traditional Emirati sweet treat.",
        "Manakish – Often called 'Arabic Pizza,' this flatbread topped with za'atar or cheese is a breakfast staple.",
        "Kite Beach Cafés – For those who want a casual vibe with sand between their toes and great food."
      ]
    }
  ],
  carouselImages: [
    { id: "fd-1", img: d2, alt: "Vibrant street food stalls in Old Dubai" },
  ],
},

 {
  id: "dubai-nightlife-bars-clubs",
  title: "Dubai Nightlife Guide: Best Clubs, Bars & Evening Shows",
  paragraphs: [
    `When the sun sets, Dubai transforms into a glittering playground of neon lights and high-octane energy. The city doesn’t just do nightlife; it hosts some of the most sophisticated and high-tech evening experiences on the planet.`,
    `Whether you’re looking to dance under the stars at a world-class beach club or enjoy a quiet, sophisticated cocktail overlooking the marina, Dubai’s after-dark scene is as diverse as it is glamorous.`
  ],
  subSections: [
    {
      title: "Clubs, Lounges & Sky-High Sips",
      items: [
        "Atmosphere (Burj Khalifa) – Sip a drink on the 122nd floor for the ultimate 'top of the world' feeling.",
        "White Dubai – An award-winning rooftop club where the music and the skyline views are equally breathtaking.",
        "Billionaire Dubai – More than just a club; it’s a high-end dinner show with world-class performers and an electric atmosphere.",
        "Soho Garden – A trendy, multi-concept space that brings a slice of London’s urban cool to the heart of the desert.",
        "Level 43 Sky Lounge – The perfect spot for a panoramic view of the Sheikh Zayed Road skyscrapers."
      ]
    },
    {
      title: "Spectacular Shows & Late-Night Walks",
      items: [
        "La Perle by Dragone – A mind-blowing aqua show featuring acrobats diving into a stage-pool from 25 meters high. It's a must-watch.",
        "Dubai Marina Night Walk – Take a slow stroll along the waterfront where the reflections of illuminated skyscrapers dance on the water.",
        "Global Village & Night Markets – Experience the city’s vibrant culture through late-night shopping, street food, and outdoor festivals.",
        "The Island Beach Clubs – Spend your night at places like Nikki Beach or Bla Bla for those iconic Dubai party vibes."
      ]
    }
  ],
  carouselImages: [
    { id: "nl-1", img: d9, alt: "The shimmering lights of Dubai Marina at night" },
  ],
},


{
  id: "dubai-honeymoon-packages-romantic-spots",
  title: "Dubai Honeymoon Guide: Most Romantic Places for Couples",
  paragraphs: [
    `Dubai is where world-class luxury meets pure romance. There is an unmistakable magic in the air here—whether you’re watching the sunset from a private yacht or sharing a quiet moment 148 floors above the ground. Every experience feels tailor-made for two.`,
    `If you’re looking for a honeymoon that balances intimate, candlelit evenings with thrilling shared adventures, Dubai is the ultimate destination to begin your forever.`
  ],
  subSections: [
{
  title: "Unforgettable Romantic Moments",
  items: [
    {
      title: "Private Yacht Cruise",
      link: "/packages",
      desc: "Sail through the sparkling waters of Dubai Marina at sunset, with the city’s skyline glowing just for you."
    },
    "Sky-High Dining – Share a sophisticated dinner at At.mosphere in the Burj Khalifa, overlooking the entire world.",
    "Sunrise in the Skies – Drift over the vast Arabian desert in a hot air balloon as the first light of day hits the dunes."
  ]
},
    {
      title: "Indulgence & Togetherness",
      items: [
        "Rejuvenating Couple Spas – Escape the hustle with a traditional Moroccan Hammam or a gold-infused massage at a world-class desert resort.",
        "Luxury Stays – From the underwater suites at Atlantis The Palm to the beachside villas of Palm Jumeirah, find your own private sanctuary.",
        "Starlit Desert Dinners – Enjoy a private, gourmet meal set in a secluded desert camp under a canopy of stars."
      ]
    }
  ],
  carouselImages: [
    { id: "hm-1", img: d4, alt: "A private yacht gliding through the Marina at sunset" },
  ],
},

    {
  id: "dubai-family-vacation-kids-activities",
  title: "Dubai Family Vacation: Best Places for Kids & Theme Parks",
  paragraphs: [
    `Dubai is extremely family-friendly with world-class theme parks, clean beaches, kids’ attractions and safe public spaces.`,
    `From high-energy rides to interactive learning zones, there’s something for every age group — making it a perfect destination for family vacations.`
  ],
  subSections: [
    {
      title: "Theme Parks & Adventure",
      items: [
        "IMG Worlds of Adventure – Indoor Marvel & Cartoon Network theme park.",
        "Motiongate Dubai – Hollywood-themed rides & attractions.",
        "Legoland Dubai – Perfect for kids with interactive rides & water park."
      ]
    },
    {
      title: "Kids & Family Experiences",
      items: [
        "Dubai Dolphinarium – Live dolphin & seal shows.",
        "KidZania Dubai Mall – Real-life roleplay city for kids.",
        "Aquaventure Waterpark – One of the best waterparks in the world."
      ]
    }
  ],
  carouselImages: [
    { id: "fm-1", img: d7, alt: "Theme park rides" },
  ],
},
{
  id: "dubai-travel-tips-for-indians",
  title: "Essential Dubai Travel Tips for Indian Tourists (2026)",
  paragraphs: [
    `Dubai is modern, safe and tourist-friendly, but a few smart tips can make your experience much smoother and hassle-free.`,
    `From cultural etiquette to travel hacks, these essentials will help you enjoy Dubai like a pro.`
  ],
  subSections: [
    {
      title: "Best Time & Planning",
      items: [
        "Best Time: November–March for pleasant weather.",
        "Avoid outdoor sightseeing during peak afternoon in summer.",
        "Prebook Burj Khalifa & Desert Safari tickets in advance."
      ]
    },
    {
      title: "Local Rules & Etiquette",
      items: [
        "Dress modestly in public & religious areas.",
        "Alcohol allowed only in licensed venues.",
        "Respect local customs and avoid public disturbances."
      ]
    },
    {
      title: "Travel Essentials",
      items: [
        "Carry a Type G travel adapter.",
        "Buy a NOL card for metro & public transport.",
        "Keep some cash for small markets & taxis."
      ]
    }
  ],
  carouselImages: [
    // { id: "tp-1", img: g2, alt: "Travel tips illustration" },
  ],
},
    {
  id: "dubai-trip-cost-budget-planner",
  title: "Dubai Trip Cost from India: 2026 Budget Planner (in INR)",
  paragraphs: [
    `Dubai can be both a luxury and budget destination depending on your planning. Whether you're traveling on a tight budget or going all-out luxury, here's a clear breakdown to help you estimate your expenses.`
  ],
  subSections: [
    {
      title: "Estimated Trip Cost (Per Person)",
      items: [
        "Budget Trip – ₹55,000 to ₹80,000 (3–4 days, basic stay & shared experiences).",
        "Standard Trip – ₹80,000 to ₹1.2 lakh (comfortable hotels & key attractions).",
        "Luxury Trip – ₹1.5 lakh+ (premium hotels, private experiences & fine dining)."
      ]
    },
    {
      title: "Free & Low-Cost Experiences",
      items: [
        "Dubai Fountain – Free musical fountain show.",
        "Public Beaches – JBR, Kite Beach & Sunset Beach.",
        "Souks – Gold Souk & Spice Souk exploration.",
        "Dubai Marina Walk – Scenic waterfront stroll."
      ]
    }
  ],
  carouselImages: [
    // { id: "bd-1", img: g1, alt: "Cost estimate infographic" },
  ],
},
  {
  id: "dubai-itinerary-5-days-7-days",
  title: "Perfect Dubai Itinerary: 5 Days to 7 Days Trip Plan",
  paragraphs: [
    `Planning your Dubai trip becomes much easier when you have a clear itinerary. Whether you're visiting for a short getaway or a detailed vacation, these plans help you cover the best experiences efficiently.`,
  ],
  subSections: [
    {
      title: "Short Trip Plans",
      items: [
        "2-Day Plan – Burj Khalifa, Dubai Mall, Desert Safari.",
        "3-Day Plan – Add Dubai Marina, Dhow Cruise, Palm Jumeirah."
      ]
    },
    {
      title: "Extended Trip Plans",
      items: [
        "5-Day Plan – Add Miracle Garden, Global Village, Atlantis The Palm."
      ]
    },
    {
      title: "Special Travel Plans",
      items: [
        "Honeymoon Plan – Yacht cruise, romantic dinner, desert camp experience.",
        "Family Plan – Theme parks, beaches & kid-friendly attractions."
      ]
    }
  ],
  carouselImages: [
    // { id: "it-1", img: g4, alt: "2-day plan highlights" },
  ],
},
  {
  id: "dubai-tourist-rules-dress-code",
  title: "Dubai Tourist Rules 2026: Dress Code, Laws & Do’s & Don’ts",
  paragraphs: [
    `Dubai follows strict laws and cultural norms, but once you understand the basics, traveling here becomes smooth and hassle-free.`,
    `Respecting local customs ensures you avoid fines and enjoy a stress-free experience.`
  ],
  subSections: [
    {
      title: "Public Behavior & Etiquette",
      items: [
        "Avoid PDA in public places.",
        "Dress modestly in mosques & cultural sites.",
        "Do not take photos of locals without permission."
      ]
    },
    {
      title: "Legal & Safety Rules",
      items: [
        "No drinking in public areas (allowed only in licensed places).",
        "Follow lane discipline and traffic rules strictly."
      ]
    }
  ],
  carouselImages: [
    // { id: "rl-1", img: g2, alt: "Respectful travel practices" },
  ],
},
  {
  id: "dubai-events-festivals-2026",
  title: "Upcoming Dubai Events & Festivals (April 2026 Update)",
  paragraphs: [
    `Dubai isn’t just about luxury — it’s a city that celebrates everything at a grand scale. From shopping carnivals to cultural festivals, timing your visit right can completely transform your experience.`,
  ],
  subSections: [
    {
      title: "Major Festivals",
      items: [
        "Dubai Shopping Festival (DSF) – Massive discounts, concerts & city-wide celebrations (Dec–Jan).",
        "Dubai Food Festival – Culinary events, street food & fine dining experiences.",
        "Dubai Fitness Challenge – 30-day citywide fitness movement with free events."
      ]
    },
    {
      title: "Cultural & National Events",
      items: [
        "Ramadan Cultural Events – Traditional markets, Iftar experiences & night bazaars.",
        "UAE National Day – Fireworks, parades & patriotic celebrations across the city."
      ]
    },
    {
      title: "Special Highlights",
      items: [
        "New Year’s Eve Burj Khalifa Fireworks – One of the world’s most iconic countdown events."
      ]
    }
  ],
  carouselImages: [
    { id: "ev-1", img: d3, alt: "Dubai Shopping Festival crowd" },
  ],
}
  ];

 const dubaiFaqData = [
    {
      question: "What is the best time for a Dubai trip in 2026?",
      answer: "The best time to visit Dubai is from November to March. The weather is pleasant (15°C to 25°C), making it the peak season for outdoor sightseeing and desert safaris. If you are on a budget, consider the shoulder months of April or October.",
    },
    {
      question: "What are the Dubai visa requirements for Indian citizens in 2026?",
      answer: "Indian passport holders require a pre-arranged tourist visa (30 or 60 days). However, Indians with a valid US, UK, or Schengen visa/residency can often get a 'Visa on Arrival'. Always check the latest GDRFA or ICP portal updates before booking.",
    },
    {
      question: "How much does a 5-day Dubai vacation cost from India in 2026?",
      answer: "A budget trip costs around ₹50,000–₹65,000 per person. A mid-range experience costs ₹85,000–₹1,15,000, while luxury trips exceed ₹1,40,000. This includes flights, 3-star+ hotels, and major attractions like Burj Khalifa and Desert Safari.",
    },
    {
      question: "Which transport apps are best for local travel in Dubai?",
      answer: "For the cheapest travel, use the Dubai Metro with a 'Nol Card'. For taxis, download 'Careem' (to book 'Hala' budget taxis) or 'Uber'. You can also use the 'S’hail' app for real-time bus and metro schedules.",
    },
    {
      question: "What is the current currency exchange rate for AED to INR?",
      answer: "The local currency is the UAE Dirham (AED). As of April 2026, 1 AED is approximately ₹25.40. While cards are accepted everywhere, it's wise to carry some cash for small purchases in souks like Meena Bazaar.",
    },
    {
      question: "Is there a specific dress code for Dubai tourists in 2026?",
      answer: "Dubai is modern but respectful. In public places like malls and government buildings, keep shoulders and knees covered. Swimwear is allowed at beaches and hotel pools. For mosque visits, full-coverage clothing (Abaya for women) is mandatory.",
    },
    {
      question: "Are Indian vegetarian and Jain food options available in Dubai?",
      answer: "Absolutely! Areas like Bur Dubai and Karama are hubs for authentic Indian food. Many restaurants offer dedicated Jain and pure-veg menus, and even global chains in Dubai Mall have extensive vegetarian sections.",
    }
  ];


  const sectionIds = sections.map(s => s.id);
  useScrollSpy(sectionIds);
  
  const blogPostingSchema = {
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "headline": "Dubai Travel Guide 2026: Luxury, Budget, Itinerary & Tips",
  "description": "Complete Dubai travel guide covering top attractions, itinerary, trip cost, shopping, beaches, and travel tips for Indian tourists.",
  "image": "https://atlastravelhouse.com/images/dubai.webp", // change to your actual URL
  "author": {
    "@type": "Organization",
    "name": "Atlas Travel House"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Atlas Travel House",
    "logo": {
      "@type": "ImageObject",
      "url": "https://atlastravelhouse.com/static/media/logo1.66d15f79b08a7465ccf7.png"
    }
  },
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://atlastravelhouse.com/blog/Travelinternational/dubai-luxury-adventure#%20Best%20Places%20to%20Visit%20in%20Dubai%20in%202026"
  }
};
  
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": dubaiFaqData.map(item => ({
    "@type": "Question",
    "name": item.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": item.answer
    }
  }))
};


  return (
    <>
      <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(blogPostingSchema),
      }}
    />

    {/* FAQ Schema */}
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(faqSchema),
      }}
    />
    <article className={styles.blogContainer}>
      <header className={styles.hero}>
        <img src={d10} alt="Dubai skyline" className={styles.heroImg} />
        <div className={styles.heroOverlay} />
        <div className={styles.heroText}>
          <h1>Dubai Travel Guide 2026: Luxury, Budget, Itinerary & Tips</h1>
          <p>Plan your Dubai trip with top attractions, travel tips, and itinerary ideas.</p>
        </div>
      </header>

   <section className={styles.factsSection}> 
  {/* SEO Tip: Heading me target keyword add kiya hai */}
  <h2 className={styles.sectionHeading}>Dubai Trip Essentials: Quick Facts for 2026</h2>

  <div className={styles.factsGrid}>
    {/* Best Time: Specific temperature mention kiya hai for authority */}
    <div className={styles.factCard}>
      <h3>Best Time to Visit</h3>
      <p>November to March (15°C–25°C). Peak season for Dubai Shopping Festival & outdoor events.</p>
    </div>

    {/* Currency: INR conversion add karna Indian readers ke liye high-intent hai */}
    <div className={styles.factCard}>
      <h3>Currency & Exchange</h3>
      <p>UAE Dirham (AED). 1 AED ≈ ₹25.40 (April 2026). Cards are standard; carry cash for Souks.</p>
    </div>

    {/* Connectivity: Travel tips for tourists */}
    <div className={styles.factCard}>
      <h3>Communication</h3>
      <p>English is the main tourist language. Get a 'Visitor SIM' (Du/Etisalat) at the airport.</p>
    </div>

    {/* Visa: Indian specific keyword ranking ke liye */}
    <div className={styles.factCard}>
      <h3>Visa for Indians</h3>
      <p>E-visa required (30/60 days). Visa-on-arrival available for Indians with valid US/UK/Schengen visa.</p>
    </div>

    {/* Transport: Tech-heavy info for ranking */}
    <div className={styles.factCard}>
      <h3>Local Transport</h3>
      <p>Dubai Metro (Nol Card) is cheapest. Use Careem or Hala Taxi for easy app-based booking.</p>
    </div>

    {/* Trip Duration: Specific days for snippet ranking */}
    <div className={styles.factCard}>
      <h3>Ideal Trip Duration</h3>
      <p>5 to 7 Days is perfect to cover Burj Khalifa, Desert Safari, and Expo City highlights.</p>
    </div>
  </div>
</section>
<div className={styles.topSection}>
  
  {/* LEFT: Table of Contents */}
  <div className={styles.toc}>
    <h3>On This Page</h3>
    <ul>
      {sections.map(sec => (
        <li key={sec.id}>
          <a href={`#${sec.id}`}>{sec.title}</a>
        </li>
      ))}
    </ul>
  </div>

  {/* RIGHT: Why Choose Us */}
  <div className={styles.whyChoose}>
    <h3>Why Choose Atlas Travel House</h3>
    <ul>
      <li>Customized Dubai itineraries based on your travel style</li>
      <li>Best price guarantee with premium hotel options</li>
      <li>End-to-end support: visa, transfers, activities</li>
      <li>Trusted by 100+ international FIT and Group travelers</li>
      <li>24/7 on-trip assistance for a stress-free experience</li>
    </ul>

    <a href="/contact" className={styles.ctaBtn}>
      Plan Your Trip
    </a>
  </div>

</div>

      <main className={styles.article}>
        {/* <aside className={styles.sidebar}>
          <h3>On This Page</h3>
          <ul>{sections.map((sec) => (<li key={sec.id}><a href={`#${sec.id}`}>{sec.title}</a></li>))}</ul>
        </aside> */}

       <div className={styles.content}>
         <CTASection
        heading="Plan Your Perfect Dubai Experience"
        description="From luxury stays and desert safaris to curated itineraries and visa support — let Atlas Travel House handle everything while you enjoy Dubai stress-free."
        buttonText="Plan Your Dubai Trip"
        buttonLink="tel:+919876543210"
      />
  {sections.map((sec) => (
    <section id={sec.id} key={sec.id} className={styles.contentBlock}>
      <h2>{sec.title}</h2>

      {sec.paragraphs.map((para, i) => (
        <p key={i}>{para}</p>
      ))}

      <Carousel images={sec.carouselImages} interval={1500} showDots={true} />

      {/* SubSections (New Structure) */}
      {sec.subSections ? (
        sec.subSections.map((sub, i) => (
          <div key={i}>
            <h3>{sub.title}</h3>
            <ul className={styles.bulletList}>
              {sub.items.map((item, j) => (
                <li key={j}>
                  {typeof item === "object" ? (
                    <>
                      <a href={item.link} className={styles.inlineLink}>
                        {item.title}
                      </a>{" "}
                      – {item.desc}
                    </>
                  ) : (
                    item
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))
      ) : (
        /* Fallback for old bullets (if any section still uses it) */
        <ul className={styles.bulletList}>
          {sec.bullets?.map((bullet, i) => (
            <li key={i}>{bullet}</li>
          ))}
        </ul>
      )}

      <hr />
    </section>
  ))}
</div>


<hr/>
        
      </main>

      <CTASection
        heading="Plan Your Perfect Dubai Experience"
        description="From luxury stays and desert safaris to curated itineraries and visa support — let Atlas Travel House handle everything while you enjoy Dubai stress-free."
        buttonText="Plan Your Dubai Trip"
        buttonLink="tel:+919876543210"
      />

      <section className={styles.faqWrapper}>
        <div className={styles.faqSection}>
          <FAQSection data={dubaiFaqData} />
        </div>

        <aside className={styles.tipsSidebar}>
          <PromoSidebar
            offers={[
              {
                id: 1,
                title: "🔥 Dubai Luxury Deal",
                desc: "Enjoy up to 25% OFF on Dubai holiday packages — Burj Khalifa, Desert Safari, Palm Jumeirah included!",
                btn: "Book Dubai Trip",
                images: [d10],
              },
            ]}
          />
        </aside>
      </section>

    

      {/* <FooterBottom /> */}
    </article>
    </>
  );
}
